import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import Loading from 'react-simple-loading';

import StoreContext, { initialStoreValues } from 'stores/StoreContextProvider';
import useOrientation from 'hooks/useOrientation';

import App from './App';


const THEME = createMuiTheme({ typography: { fontFamily: '"Helvetica Neue", "Arial", "Helvetica", sans-serif' } });

const Root = ({ store, history }) => {
  useOrientation();

  return (
    <MuiThemeProvider theme={THEME}>
      <StoreContext.Provider value={initialStoreValues}>
        <Provider store={store}>
          <Suspense fallback={<Loading />}>
            <Router history={history}>
              <App />
            </Router>
          </Suspense>
        </Provider>
      </StoreContext.Provider>
    </MuiThemeProvider>
  );
};

Root.propTypes = {
  history: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
};

export default Root;
